import { OidcProvider } from "@axa-fr/react-oidc";
import React from "react";
import { render, unmountComponentAtNode } from "react-dom";

import { ErrorBoundary, Fallback, Loader, Toast } from "@sicredi/react";

import App from "#/App";
import { onResponse } from "#/utils/request";
import { startApiMockServer } from "./api/__mocks__";
import oidcConfiguration from "./oidcConfiguration";

import { defineCustomElements } from "@diana-kit/react";
import { googleTagManagerSetup } from "@sicredi/tag-manager-web";
import { hotjar } from "react-hotjar";
import { HOTJAR } from "./constants";
import "./global.scss";

const loadingComponent = () => <Loader show fullScreen />;

const ROOT = document.getElementById("root")!;

googleTagManagerSetup().initialize({
  config: {
    containerId: window.env.GTM_CONTAINER_ID,
    debug: false,
    userId: null,
  },
});

function unmountRender(element: React.ReactElement) {
  unmountComponentAtNode(ROOT);
  render(element, ROOT);
}

unmountRender(loadingComponent());

if (window.env.MOCK) {
  startApiMockServer({});
}

onResponse((response) => {
  function handleClose() {
    window.auth.actions.logout();
    window.location.reload();
  }

  if (response?.status === 401) {
    unmountRender(
      <Fallback title="Acesso negado" onClose={handleClose}>
        Você não possui autorização para acessar essa aplicação.
      </Fallback>
    );
  }
});

defineCustomElements(window);

unmountRender(
  <ErrorBoundary
    onClose={() => {
      window.location.reload();
    }}
  >
    <OidcProvider
      configuration={oidcConfiguration}
      loadingComponent={loadingComponent}
      authenticatingComponent={loadingComponent}
      callbackSuccessComponent={loadingComponent}
      authenticatingErrorComponent={Fallback}
    >
      <Toast />
      <App />
    </OidcProvider>
  </ErrorBoundary>
);

if (HOTJAR.HJID) {
  hotjar.initialize({ sv: HOTJAR.HJSV, id: HOTJAR.HJID });
}
